import { createSlice } from "@reduxjs/toolkit";

export const assessorSlice = createSlice({
  name: "assessor",
  initialState: {
    value: {
      searchStatus: null,
      cids: [],
      data: [],
      mils: 0,
      form: {
        transferID: -1,
        cid: "",
        parcelID: "",
        ownerName: "NOT FOUND",
        ownerMailing: "NOT FOUND",
        buildingAddress: "NOT FOUND",
        assessorValue: 0,
        cidValue: 0,
        propertyDesc: "",
        contactID: null,
        contactIDs: [],
        exempt: false,
        flagColor: null,
        customFields: {},
        latitude: null,
        longitude: null,
        importModalOpen: false,
      },
      filters: {
        markers: [],
        custom: {},
      },
    },
  },
  reducers: {
    setMarker: (state, action) => {
      state.value.form.flagColor = action.payload
    },
    setCustomFieldValue: (state, action) => {
      const { name, value } = action.payload;
      if (value === "" || value === null || value === undefined) {
        delete state.value.form.customFields[name];
      } else {
        state.value.form.customFields[name] = value;
      }
    },
    setCustomFields: (state, action) => {
      state.value.form.customFields =
        action.payload && typeof action.payload === "object" ? action.payload : {};
    },
    setMarkerFilters: (state, action) => {
      state.value.filters.markers = Array.isArray(action.payload) ? action.payload : [];
    },
    setCustomFilter: (state, action) => {
      const { name, filter } = action.payload;
      if (!filter) {
        delete state.value.filters.custom[name];
      } else {
        state.value.filters.custom[name] = filter;
      }
    },
    clearFilters: (state) => {
      state.value.filters = { markers: [], custom: {} };
    },
    setMils: (state, action) => {
      state.value.mils = action.payload
    },
    setTransferID: (state, action) => {
      state.value.form.transferID = action.payload;
    },
    changeCID: (state, action) => {
      state.value.form.cid = action.payload.cid;
      state.value.data = action.payload.data;
    },
    pushData: (state, action) => {
      state.value.data.push(action.payload);
    },
    setCID: (state, action) => {
      state.value.form.cid = action.payload;
    },
    setCIDS: (state, action) => {
      state.value.cids = action.payload;
    },
    setData: (state, action) => {
      state.value.data = action.payload;
    },
    setImportModal: (state, action) => {
      state.value.form.importModalOpen = action.payload;
    },
    resetForm: (state) => {
      state.value.form = {
        transferID: -1,
        cid: state.value.form.cid,
        parcelID: "",
        ownerName: "NOT FOUND",
        ownerMailing: "NOT FOUND",
        buildingAddress: "NOT FOUND",
        assessorValue: 0,
        cidValue: 0,
        propertyDesc: "",
        contactID: null,
        contactIDs: [],
        exempt: false,
        flagColor: null,
        customFields: {},
        latitude: null,
        longitude: null,
        importModalOpen: state.value.form.importModalOpen ?? false,
      };
      state.value.searchStatus = null;
    },
    deleteProperties: (state, action) => {
      state.value.data.forEach((p, i) => {
        if (action.payload.includes(p.id)) {
          state.value.data.splice(i, 1);
        }
      });
    },
    setForm: (state, action) => {
      state.value.form = action.payload;
    },
    setParcelID: (state, action) => {
      state.value.form.parcelID = action.payload;
    },
    setOwnerName: (state, action) => {
      state.value.form.ownerName = action.payload;
    },
    setOwnerMailing: (state, action) => {
      state.value.form.ownerMailing = action.payload;
    },
    setBuildingAddr: (state, action) => {
      state.value.form.buildingAddress = action.payload;
    },
    setAssessorCIDValue: (state, action) => {
      state.value.form.assessorValue = parseInt(action.payload);
      if (!state.value.form.exempt) {
        state.value.form.cidValue = parseInt(action.payload) * parseFloat(state.value.mils);
      } else {
        state.value.form.cidValue = 0;
      }
      
    },
    setAssessorValue: (state, action) => {
      state.value.form.assessorValue = parseFloat(action.payload)
    },
    setCIDValue: (state, action) => {
      state.value.form.cidValue = parseFloat(action.payload);
    },
    setContact: (state, action) => {
      state.value.form.contactID = action.payload;
    },
    setContacts: (state, action) => {
      const ids = Array.isArray(action.payload)
        ? Array.from(
            new Set(
              action.payload
                .map((value) => parseInt(value, 10))
                .filter((value) => Number.isInteger(value) && value > 0)
            )
          )
        : [];
      state.value.form.contactIDs = ids;
      state.value.form.contactID = ids.length ? ids[0] : null;
    },
    setPropertyDesc: (state, action) => {
      state.value.form.propertyDesc = action.payload;
    },
    setExempt: (state, action) => {
      if (!action.payload) {
        state.value.form.cidValue = state.value.mils * state.value.form.assessorValue;
        state.value.form.exempt = false;
      } else {
        state.value.form.cidValue = 0 * state.value.form.assessorValue;
        state.value.form.exempt = true;
      }
    },
    setSearchStatus: (state, action) => {
      state.value.searchStatus = action.payload
    },
    setCoordinates: (state, action) => {
      const { latitude, longitude } = action.payload || {};
      state.value.form.latitude = Number.isFinite(latitude) ? latitude : null;
      state.value.form.longitude = Number.isFinite(longitude) ? longitude : null;
    }
  },
});

export const {
  setCustomFieldValue,
  setCustomFields,
  setMarkerFilters,
  setCustomFilter,
  clearFilters,
  setCID,
  setParcelID,
  setForm,
  deleteProperties,
  changeCID,
  pushData,
  setCIDS,
  setData,
  setOwnerName,
  setOwnerMailing,
  setBuildingAddr,
  setExempt,
  setAssessorCIDValue,
  setContact,
  setContacts,
  setPropertyDesc,
  setCIDValue,
  setSearchStatus,
  setAssessorValue,
  setTransferID,
  resetForm,
  setMils,
  setMarker,
  setImportModal,
  setCoordinates
} = assessorSlice.actions;

export default assessorSlice.reducer;
